import Axios from "../../../networking/interceptor";

import { createAsyncThunk } from "@reduxjs/toolkit";
import { oat_driver_login } from "../../../networking/urlEndPoints";
import { authSelectedPharmacy } from "./authSelectedPharmacy";

import { fetchPharmacyDetails } from "../dispense/getPharmacyDetail";
import { setDriverDefaultRoute } from "../../slices/auth/driverDefaultRoute";
import { clearSelectedPharmacistID } from "../../slices/auth/selectedPharmacist";

import * as routeNames from '../../../routes/routeName';
import * as Storage from '../../../storage'
import { setAuthToken } from '../../../storage/authToken';

export const authLogin = createAsyncThunk('authLogin', async (userDetail, { rejectWithValue }) => {

	try {
		const requesteData = {
			email: userDetail?.email,
			password: userDetail?.password,
			passcode: userDetail?.passcode
		}

		const response = await Axios.post(oat_driver_login, requesteData);
		const data = response.data;

		setAuthToken(data?.data?.token)

		if (typeof userDetail.navigate === 'function') {

			if (data?.data?.driver_pharmacy?.pharmacies) {
				// Show the "Pharmacist of the Day" popup once per login.
				// Clear any prior dismissal in this tab/session so it opens after each login.
				try {
					const pharmacyId = data?.data?.driver_pharmacy?.pharmacy_id;
					if (pharmacyId) {
						sessionStorage.removeItem(`instore.defaultPharmacist.dismissed.${pharmacyId}`);
					}
					sessionStorage.removeItem(`instore.defaultPharmacist.dismissed.unknown`);
				} catch (e) { }

				userDetail.dispatch(authSelectedPharmacy(data?.data?.driver_pharmacy?.pharmacies))
				userDetail.dispatch(clearSelectedPharmacistID())
				userDetail.dispatch(fetchPharmacyDetails(data?.data?.driver_pharmacy?.pharmacy_id))
				userDetail.dispatch(setDriverDefaultRoute(data?.data?.driver_default_route))
				userDetail.navigate(`${routeNames.DASHBOARD_PHARMACY}`)
				localStorage.removeItem(Storage.todayPendingRoute)
			}

		}

		return data;

	} catch (error) {
		return rejectWithValue(error.response)
	}

})
